import { fade } from "@material-ui/core/styles/colorManipulator";

export const styles = theme => ({
  root: {
    width: "100%",
    flexDirection: "row"
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    flexDirection: "row",
    marginLeft: -12,
    marginRight: 15,
    [theme.breakpoints.down(365)]: {
      marginRight: 5
    }
  },
  title: {
    display: "none",
    fontFamily: `"Montserrat", sans-serif`,
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  search: {
    flexDirection: "row",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing.unit * 2,
    marginLeft: 0,
    minWidth: "225px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit * 3,
      width: "auto"
    },
    [theme.breakpoints.down(365)]: {
      // marginLeft: theme.spacing.unit * 3,
      width: "auto",
      minWidth: 180,
      marginLeft: 0,
      marginRight: 0
    }
  },
  searchIcon: {
    flexDirection: "row",
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 .5rem"
  },
  inputRoot: {
    flexDirection: "row",
    color: "inherit",
    width: "100%"
  },
  inputInput: {
    flexDirection: "row",
    paddingTop: theme.spacing.unit,
    // paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: "2.5rem",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up(350)]: {
      width: 200
    }
  },
  sectionDesktop: {
    flexDirection: "row",
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  },
  sectionMobile: {
    flexDirection: "row",
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  }
});
